export default {
    revert_rma_title: "Revert RMA",
    revert_rma_input: "IMEI or Serial",
    revert_rma_imei: "IMEI",
    revert_rma_serial: "Serial",
    revert_rma_model: "Model",
    revert_rma_change: "Revert",
    revert_rma_no_devices_added: "No devices added",
    revert_rma_device_is_already_added: "The device is already added",
    revert_rma_device_has_not_been_found: "The device has not been found",
    revert_rma_this_feature_is_not_available: "This feature is not available",
    revert_rma_single_success_message: "The RMA mark has been deleted from the device",
    revert_rma_multiple_success_message: "The RMA mark has been deleted from the devices",
    revert_rma_error_message: "Unable to delete the RMA mark due to an error",
    revert_rma_show_in_web: "Show In Web",
    revert_rma_number: "RMA Number",
    revert_rma_device_is_not_rma: "The device is not marked as RMA",
    revert_rma_device_is_already_refirbished: "The device is already refurbished",
    revert_rma_devices_is_not_rma: "There aren't devices marked as RMA",
    revert_rma_devices_is_already_refirbished: "There are devices already refurbished",
    revert_rma_revert_message_single: "The RMA mark will be deleted from this device and the status will be changed to ACTIVE",
    revert_rma_revert_message: "The RMA mark will be deleted from this devices and the status will be changed to ACTIVE",
}

